import { actionTypes } from '../../../types';

export const downloadReferenceVideo = (payload, callback) => ({
    type: actionTypes.DOWNLOAD_REFERENCE_VIDEO_REQUEST,
    payload,
    callback,
});

export const downloadReferenceVideoSuccess = (payload) => ({
    type: actionTypes.DOWNLOAD_REFERENCE_VIDEO_SUCCESS,
    payload,
});

export const downloadReferenceVideoFailure = (payload) => ({
    type: actionTypes.DOWNLOAD_REFERENCE_VIDEO_FAILURE,
    payload,
});

export const downloadReferenceVideoReset = () => ({
    type: actionTypes.DOWNLOAD_REFERENCE_VIDEO_RESET,
});

export const downloadReferenceVideoResetAll = () => ({
    type: actionTypes.DOWNLOAD_REFERENCE_VIDEO_RESET_ALL,
});
